module.exports = __webpack_public_path__ + "3dda3acd9b72f4468bb687b1dcb4b75a.svg";